module.exports = "/_next/static/images/video_id_7132941291100343598-2e5d4084944d010ada7b1cf2ba387ec8.jpg";